import config from 'config';
import { replace } from 'redux-little-router';
import { call, put, takeLatest } from 'redux-saga/effects';

import { routeMap } from 'router';
import Storage from 'services/Storage';
import { check } from '../../services/API';

import { actionTypes, requestFailure, requestSuccess } from './actions';

function* handleLogin(action) {
  const response = yield call(check, action.payload.token);

  if (response.isOk) {
    yield put(requestSuccess(response.data));
    yield put(replace(action.payload.redirectUrl || routeMap.home));
  } else {
    yield put(replace(routeMap.login));
    yield put(requestFailure(response.error));
    yield Storage.removeItem(config.tokenItemName);
    yield Storage.removeItem(config.refreshTokenItemName);
  }
}

export default function* checkTokenSaga() {
  yield takeLatest(actionTypes.REQUEST_START, handleLogin);
}
